import { Col, Row, Grid, Card } from "antd"
import { useAuth } from "../../context";
import WalletBalance from "../../components/wallet/WalletBalance";
import TransactionsTable from "../../components/wallet/TransactionsTable";
import { useTransactions } from "../../hooks/useTransactions";
import WalletInfoAlert from "../../components/wallet/WalletInfoAlert";


const Wallet = () => {

    const { useBreakpoint } = Grid;

    const screens = useBreakpoint();

    const { user } = useAuth();

    //console.log(user)

    const { transactions, fetchTransactions, loadWallet, setLoadWallet } = useTransactions();

    return (
        <>
            <WalletInfoAlert />
            <Row gutter={[16, 16]}>
                <Col xs={24} md={24}>
                    <WalletBalance
                        balance={user?.walletBalance}
                        fetchTransactions={fetchTransactions}
                        loading={loadWallet}
                        setLoading={setLoadWallet}
                    />
                </Col>

                <Col xs={24} md={24}>
                    <Card>
                        <TransactionsTable
                            transactions={transactions}
                            isMobile={!screens.md}
                            loading={loadWallet}
                            isAdmin={false}
                            refresh={fetchTransactions}
                        />
                    </Card>
                </Col>


            </Row>
        </>
    )
}

export default Wallet